"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  basket: 'basket',
  cataloguePrice: 'Catalogue price',
  delete: 'Delete',
  emptyBag: 'Empty bag',
  emptyBagMessage: 'Looking pretty empty in your bag',
  goToBasket: 'Go to basket',
  qty: 'qty',
  quantity: 'Quantity',
  regularPrice: 'Regular price',
  superdeal: 'superdeal',
  unitPrice: 'Unit price'
};
const translationsNamespace = exports.translationsNamespace = 'mini-shopping-bag';